export default {
  getMap (onderzoek) {
    return {
      CONTRACTOR: contractor(onderzoek),
      // CLient
      CLIENT_NAME: clientName(onderzoek),
      CLIENT_ADDRESS: clientAddress(onderzoek),
      CLIENT_POSTAL_CODE: clientPostalCode(onderzoek),
      CLIENT_CITY: clientCity(onderzoek),
      CLIENT_TELEPHONE: clientTel(onderzoek),
      CLIENT_CONTACT: clientContact(onderzoek),
      CLIENT_EMAIL: clientEmail(onderzoek),
      // Surveyor company
      SURVEYOR_USERS: surveyors(onderzoek),
      SURVEYORS: surveyor(onderzoek),
      SURVEYOR_ADDRESS: surveyCompanyAddress(onderzoek),
      SURVEYOR_NAME: surveyCompanyName(onderzoek),
      SURVEYOR_CITY: surveyCompanyCity(onderzoek),
      SURVEYOR_POSTAL_CODE: surveyCompanyPostalCode(onderzoek),
      SURVEYOR_COUNTRY: surveyCompanyCountry(onderzoek),
      // Survey info
      SURVEY_SCOPE: surveyScope(onderzoek),
      SURVEY_ADDRESS: surveyAddress(onderzoek),
      SURVEY_PERIOD: surveyPeriod(onderzoek),
      SURVEY_TYPE: surveyType(onderzoek),
      SURVEY_TEL: surveyTel(onderzoek),
      SURVEY_FAX: surveyFax(onderzoek),
      REIKWIJDTES: reikwijdtes(onderzoek),
      ONDERZOEK_DOELEN: onderzoekDoelen(onderzoek),
      // Onderzoek info
      ONDERZOEK_NUMBER: onderzoekNumber(onderzoek),
      // Laboratoria
      LABORATORIES: laboratories(onderzoek),
      // Survey
      SAMPLE_CERTIFICATES: sampleCertificates(onderzoek),
      DESK_RESEARCH: deskResearch(onderzoek),
      SURVEY_PLAN: surveyPlan(onderzoek),
      SURVEY_LIMITATIONS: surveyLimitations(onderzoek),
      // Asset
      ASSET: asset(onderzoek)
    }
  }
}

const getNested = (obj, nestedList) => {
  let ret = obj
  for (let i = 0; i < nestedList.length; i++) {
    if (ret[nestedList[i]]) {
      ret = ret[nestedList[i]]
    }
    else {
      console.warn('nested property ' + nestedList[i] + ' not found in ', obj)
      return false
    }
  }

  return ret
}

function contractor (onderzoek) {
//  TODO make real contractor

  return {
    naam: 'Kiwa Comppliance',
    bezoek_straat: 'Honkongstraat 5',
    bezoek_postcode: '3047 BR',
    bezoek_plaats: 'Rotterdam',
    bezoek_land: 'The Netherlands',
    telefoon_nummer: '+31 (0)10 – 208 84 44',
    website: 'www.kiwaoesterbaai.com'
  }
}

function asset (onderzoek) {
  const asset = getNested(onderzoek, ['inventarisatie_asset', 'asset'])

  return asset || {}
}

function reikwijdtes (onderzoek) {
  return []
}

function onderzoekDoelen (onderzoek) {
  return []
}

// CLIENT

function clientName (onderzoek) {
  return (onderzoek.onderzoek_klant && onderzoek.onderzoek_klant.naam) || '-'
}

function clientAddress (onderzoek) {
  return (onderzoek.onderzoek_klant && onderzoek.onderzoek_klant.bezoek_straat) || '-'
}

function clientPostalCode (onderzoek) {
  console.log('ONDERZOEK.ONDERZOEK_KLANT', onderzoek.onderzoek_klant)
  return (onderzoek.onderzoek_klant && onderzoek.onderzoek_klant.bezoek_postcode) || '-'
}

function clientCity (onderzoek) {
  return (onderzoek.onderzoek_klant && onderzoek.onderzoek_klant.bezoek_plaats) || '-'
}

function clientTel (onderzoek) {
  return (onderzoek.onderzoek_klant && onderzoek.onderzoek_klant.telefoon_nummer) || '-'
}

function clientEmail (onderzoek) {
  return onderzoek.onderzoek_klant?.email || '-'
}

function clientContact (onderzoek) {
  console.log('.CONTACT_PERSOON', onderzoek.contact_persoon)
  return onderzoek.contact_persoon?.naam || '-'
}

// SURVEYOR COMPANY
function surveyors (onderzoek) {
  const surveyors = []
  for (let i = 0; i < onderzoek.inventarisaties.length; i++) {
    if (onderzoek.inventarisaties[i].inventarisatie_user?.user) {
      surveyors.push(onderzoek.inventarisaties[i].inventarisatie_user)
    }
  }

  return surveyors
}

function surveyor (onderzoek) {
  let returnString = ''
  for (let i = 0; i < onderzoek.inventarisaties.length; i++) {
    if (onderzoek.inventarisaties[i].inventarisatie_user?.user) {
      if (i > 0) returnString += ', '

      returnString += onderzoek.inventarisaties[i].inventarisatie_user.user.name
    }
  }

  return returnString
}

function surveyTel (onderzoek) {
  // TODO
  return '03 871 97 50'
}

function surveyFax (onderzoek) {
  // TODO
  return '03 312 95 99'
}

function surveyCompanyName (onderzoek) {
  // TODO
  return 'Kiwa Oesterbaai N.V.'
}

function surveyCompanyAddress (onderzoek) {
  // TODO
  return 'Kontichsesteenweg 42'
}

function surveyCompanyCity (onderzoek) {
  // TODO
  return 'Aartselaar'
}

function surveyCompanyPostalCode (onderzoek) {
  // TODO
  return '2630'
}

function surveyCompanyCountry (onderzoek) {
  // TODO
  return 'Belgium'
}

// SURVEY

function surveyScope (onderzoek) {
  let returnString = ''
  if (onderzoek.omvang) {
    returnString += onderzoek.omvang
  }
  return returnString.length ? returnString : '-'
}

function surveyType (onderzoek) {
  let returnString = ''
  if (onderzoek.onderzoek_type?.value) {
    returnString += onderzoek.onderzoek_type.value
  }
  return returnString.length ? returnString : '-'
}

function surveyAddress (onderzoek) {
  let returnString = ''
  const asset = getNested(onderzoek, ['inventarisatie_asset', 'asset'])
  if (asset) {
    returnString += `${asset.straatnaam} ${asset.huisnummer}${asset.toevoeging ? ' ' + asset.toevoeging : ''} te ${asset.plaats}`
  }
  return returnString.length ? returnString : '-'
}

function surveyPeriod (onderzoek) {
  let returnString = ''
  if (onderzoek.startDatum) {
    returnString += onderzoek.startDatum
  }
  if (onderzoek.eindDatum) {
    returnString += ' - ' + onderzoek.eindDatum
  }
  return returnString.length ? returnString : '-'
}

// ONDERZOEK

function onderzoekNumber (onderzoek) {
  const number = getNested(onderzoek, ['nummer'])
  return number || '-'
}

// LABORATORIA

function laboratories (onderzoek) {
  // TODO
  return '-'
}

// SURVEY
function sampleCertificates (onderzoek) {
  const certificates = []
  const inventarisaties = onderzoek.inventarisaties
  if (inventarisaties.length) {
    for (let i = 0; i < inventarisaties.length; i++) {
      const bronInventarisaties = inventarisaties[i].bron_locatie_inventarisaties
      if (bronInventarisaties.length) {
        for (let j = 0; j < bronInventarisaties.length; j++) {
          const monsters = bronInventarisaties[j].monsters
          if (monsters.length) {
            for (let k = 0; k < monsters.length; k++) {
              if (!certificates.includes(monsters[k].analyseCertificaat)) {
                certificates.push(monsters[k].analyseCertificaat)
              }
            }
          }
        }
      }
    }
  }

  return certificates
}

function deskResearch (onderzoek) {
  return onderzoek.documenten?.length ? onderzoek.documenten : []
}

function surveyPlan (onderzoek) {
  return onderzoek.reikwijdte_tekening
}

function surveyLimitations (onderzoek) {
  return onderzoek.onderzoek_beperkingen.length ? onderzoek.onderzoek_beperkingen : []
}
